'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Action Types
var DOCUMENT_MODE_CALCULATION = exports.DOCUMENT_MODE_CALCULATION = 'DOCUMENT_MODE_CALCULATION';


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/mobile/documentModeConstants.js
// module id = 2211
// module chunks = 0